"use strict";var i=require("styled-components").css`
    position: relative;
    padding: 47px ${({theme:i})=>i.spacing.large} 53px;
    background: ${({theme:i})=>i.colors.grey[50]};

    @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
        padding: 85px ${({theme:i})=>i.spacing.large} 98px;
    }

    .inner {
        margin: 0 auto;
        padding: 0;
        display: grid;
        grid-row-gap: 50px;
        width: 100%;
        box-sizing: border-box;

        @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
            padding: 0;
        }
    }

    header {
        padding-bottom: 39px;

        h2 {
            margin: 0;
        }
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: grid;
        grid-row-gap: 17px;

        @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
            grid-template-columns: repeat(3, 1fr);
            grid-row-gap: 21px;
        }
    }

    li {
        margin: 0;
        padding: 0;

        .inline-svg {
            svg {
                width: 48px;
                height: 48px;
                color: ${({theme:i})=>i.colors.primary.dark};

                path {
                    fill: currentColor;
                }
            }
        }

        p {
            span {
                display: block;
            }
        }
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
